import { HTTP_INTERCEPTORS } from '@angular/common/http';

//import { RequestTimestampService } from './request-timestamp.service';
import { RetryInterceptorService } from './retry-interceptor.service';
import { WebApiBaseURLInterceptor } from './web-api-base-url-interceptor';

export const interceptorProviders =
    [
        // { provide: HTTP_INTERCEPTORS, useClass: RequestTimestampService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: WebApiBaseURLInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: RetryInterceptorService, multi: true }
    ];
